/**
 * Хуки данных модуля «Поставщики» (подрядчики/вендоры) — менеджеру/владельцу.
 *
 * Бэк: internal/vendor_module — GET /v1/vendors?state= → { items, count }
 * (handlers_extra.ListVendors). RBAC: vendor.* capability (owner/manager).
 * Состояния KYC: pending_review / approved / rejected / suspended.
 *
 * Server-state только через React Query. Мутаций на менеджерском списке нет
 * (создание/KYC — отдельный воркфлоу), экран — обзорный реестр поставщиков.
 */
import { useQuery } from '@tanstack/react-query';
import { customFetch } from '@hsc/api-client';

/** Проекция поставщика (см. internal/vendor_module/.../dto.VendorResponse). */
export interface Vendor {
  id: string;
  tenant_id: string;
  code: string;
  display_name: string;
  kyc_state: string;
  kyc_reject_reason?: string;
  contact_email?: string;
  contact_phone?: string;
  suspended_at?: string | null;
  suspension_reason?: string;
  created_at: string;
  updated_at: string;
}

export interface VendorsResponse {
  items: Vendor[];
  count: number;
}

export function useVendors(state?: string) {
  return useQuery<VendorsResponse>({
    queryKey: ['vendors', 'list', state ?? 'all'],
    queryFn: async () => {
      const raw = await customFetch<{ items?: Vendor[]; count?: number }>({
        url: '/vendors',
        method: 'GET',
        ...(state ? { params: { state } } : {}),
      });
      return { items: raw.items ?? [], count: raw.count ?? raw.items?.length ?? 0 };
    },
    staleTime: 30_000,
  });
}
